import React from 'react'
import { Gauge } from '@mui/x-charts'
import { Flex } from 'antd'
import { t } from 'i18next'
import Title from 'antd/es/typography/Title'

export default function SlotEventsChart ({ slots }) {
  const slotsWithEvent = slots.filter((s) => s.events.length > 0)

  return (
    <Flex vertical align='center'>
      <Title level={5}>
        {t('Admin.Statistic.SlotEventsChart.title')}
      </Title>
      { slots.length > 0 &&
        <Gauge width={150} height={100} startAngle={-110} endAngle={110}
          value={slotsWithEvent.length} valueMin={0} valueMax={slots.length}
          text={({ value, valueMax }) => `${value} / ${valueMax}`}
        />
      }
      { slots.length === 0 &&
        <Gauge width={150} height={100} startAngle={-110} endAngle={110}
          value={slotsWithEvent.length}
          text={() => '0 / 0'}
        />
      }
    </Flex>
  )
}
